import { watch } from 'vue'
import { useUserStore } from '@/stores/user'

function normalizePermissions(value) {
  if (!value) return []
  return Array.isArray(value) ? value : [value]
}

function hasPermission(required, permissions) {
  if (!required || required.length === 0) return true
  const list = Array.isArray(permissions) ? permissions : []
  // 超级管理员拥有所有权限
  if (list.includes('*:*:*')) return true
  return required.some(item => list.includes(item))
}

export default {
  mounted(el, binding) {
    const userStore = useUserStore()
    const required = normalizePermissions(binding.value)

    const apply = () => {
      const allowed = hasPermission(required, userStore.permissions)
      el.style.display = allowed ? '' : 'none'
    }

    apply()
    el.__permissionStop = watch(
      () => userStore.permissions,
      () => apply(),
      { deep: true }
    )
  },
  updated(el, binding) {
    const userStore = useUserStore()
    const required = normalizePermissions(binding.value)
    const allowed = hasPermission(required, userStore.permissions)
    el.style.display = allowed ? '' : 'none'
  },
  unmounted(el) {
    if (el.__permissionStop) {
      el.__permissionStop()
    }
  }
}
